import validate from "/root/app/craft-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/root/app/craft-web/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "activation-manager": () => import("/root/app/craft-web/middleware/activation-manager.ts"),
  auth: () => import("/root/app/craft-web/middleware/auth.ts")
}